import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import useMediaQuery from '@mui/material/useMediaQuery'

import useStyles from '../assets/styles'
import {
  Button,
  Grid,
  LinearProgress,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material'
import Web3 from 'web3'
//img
import Boom from '../assets/img/boom.png'
import { useWeb3React } from '@web3-react/core'
import Config from '../config/app'
const VestingPage = () => {
  const classes = useStyles()
  const { active, account, library } = useWeb3React()
  const [vestingData, setVestingData] = useState({})
  const [scheduleId, setScheduleId] = useState()
  const [releaseAmount, setReleaseAmount] = useState()
  const [progress, setProgress] = useState(2)
  const isMobile = useMediaQuery('(max-width:600px)')

  const load = async () => {
    const web3 = new Web3(library.provider)
    const VestingContract = new web3.eth.Contract(
      Config.VestingContract.abi,
      Config.VestingContract.address,
    )
    const data = await VestingContract.methods.getVestingSchedules().call()
    let vestingSchedulesId;
    data.forEach(item => {
      console.log(item, "item");
      if (item.revoked == false && item.beneficiary == account && Number(item.released) != Number(item.amountTotal)) {
        vestingSchedulesId = item.vestingSchedulesId;
        return;
      }
    });

    console.log(vestingSchedulesId, "vestingSchedulesId")
    const vestingSchedule = await VestingContract.methods
      .getVestingSchedule(vestingSchedulesId)
      .call()

    const _releaseAmount = await VestingContract.methods
      .computeReleasableAmount(vestingSchedulesId)
      .call()
    setReleaseAmount(_releaseAmount)
    setScheduleId(vestingSchedulesId)
    setVestingData(vestingSchedule)

    if (vestingSchedulesId) {
      setInterval(() => {
        const fromnow = Number(vestingSchedule.cliff - Number(new Date().valueOf()) / 1000)
        const total = Number(vestingSchedule.cliff - vestingSchedule.start)
        console.log(fromnow, "fromnow");
        console.log(total, "total");
        if (fromnow < 0) {
          setProgress(100);
        } else {
          const val = (1 - fromnow / total) * 100

          setProgress((1 - fromnow / total) * 100)
        }
      }, 3000);
    }
  }

  const claim = async () => {
    const web3 = new Web3(library.provider)
    const VestingContract = new web3.eth.Contract(
      Config.VestingContract.abi,
      Config.VestingContract.address,
    )
    const claim = await VestingContract.methods
      .release(scheduleId, releaseAmount.toString())
      .send({ from: account })
    console.log(claim)
    load()
  }

  const formatDate = (val) => {
    const date = new Date(Number(val));
    const _formatDate = date.getDate() +
      "/" + (date.getMonth() + 1) +
      "/" + date.getFullYear() +
      " " + date.getHours() +
      ":" + date.getMinutes() +
      ":" + date.getSeconds()
    return _formatDate
  }

  const formatDuration = (val) => {
    const day = Math.floor(Number(val) / 60 / 60 / 24);
    const hours = Math.floor((val - day * 3600 * 24) / 3600);
    const minutes = Math.floor((val - day * 3600 * 24 - hours * 3600) / 60);

    return `${day ? day + " d " : ""} ${hours ? hours + " h " : ""} ${minutes ? minutes + " mins" : ""}`
  }

  useEffect(() => {
    if (active) {
      load()
    } else {
      setVestingData({})
    }
  }, [active])

  return (
    <Box className={classes.home}>
      <Box component="section" className={isMobile ? 'hero mobile' : 'hero'}>
        <Container>
          <Grid container spacing={5} justifyContent="center">
            <Grid item md={10} xs={12}>
              <Stack>
                <Typography color="white" variant="h6">Your Vesting</Typography>
              </Stack>
            </Grid>
            <Grid item md={5} xs={12} style={{ display: "flex", hegith: '100%' }}>
              <Stack spacing={5} sx={{ width: "100%" }} justifyContent="space-between">
                <Box className="item" >
                  <Stack >
                    <Stack direction="row" justifyContent="space-between">
                      <Typography className="text" variant="h6">
                        VESTING AMOUNT
                      </Typography>
                      <Button className='presale' >PRIVATE SALE</Button>
                    </Stack>
                    <Typography className="text" variant="h4">
                      {vestingData.length > 0 ? (
                        <>{vestingData.amountTotal / 10} $BOOM</>
                      ) : (
                        <Skeleton variant="text" />
                      )}
                    </Typography>
                  </Stack>
                  <Stack spacing={2} pt={5}>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography>VESTING DURATION</Typography>
                      <Typography>
                        {vestingData.length > 0 ? (
                          <>
                            {
                              formatDuration(vestingData.duration)
                            }
                          </>
                        ) : (
                          <Skeleton variant="text" />
                        )}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography className="text">Clif DURATION</Typography>
                      <Typography>
                        {vestingData.length > 0 ? (
                          <>
                            {
                              formatDuration(vestingData.slicePeriodSeconds)
                            }
                          </>
                        ) : (
                          <Skeleton variant="text" />
                        )}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography className="text">START DATE</Typography>
                      <Typography>
                        {vestingData.length > 0 ? (
                          <>
                            {
                              formatDate(vestingData.start * 1000)
                            }
                          </>
                        ) : (
                          <Skeleton variant="text" />
                        )}
                      </Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography className="text">END DATE</Typography>
                      <Typography>
                        {vestingData.length > 0 ? (
                          <>
                            {
                              formatDate(Number(vestingData.start) * 1000 +
                                Number(vestingData.duration) * 1000)
                            }
                          </>
                        ) : (
                          <Skeleton variant="text" />
                        )}
                      </Typography>
                    </Stack>

                  </Stack>
                </Box>
                <Box className="item">
                  <Stack>
                    {/* NEXT  */}
                    <Typography className="text">CLIFF REMAINING TIME</Typography>
                    <Stack pt={1} spacing={1}>
                      <LinearProgress
                        className='progress'
                        sx={{ height: '10px', borderRadius: '12px' }}
                        color="secondary"
                        variant="determinate"
                        value={progress}
                      />
                      <Typography>
                        {vestingData.length > 0 ? (

                          <>
                            {
                              Number(vestingData.cliff - Number(new Date().valueOf()) / 1000) < 0 ?
                                "0"
                                :
                                formatDuration(Number(vestingData.cliff - Number(new Date().valueOf()) / 1000))
                            } Left
                          </>
                        ) : (
                          <Skeleton variant="text" />
                        )}
                      </Typography>
                    </Stack>
                  </Stack>
                </Box>
              </Stack>
            </Grid>
            <Grid item md={5} xs={12} style={{ hegith: '100%' }}>
              <Box className="item">
                <Stack sx={{ height: '100%' }}>
                  <Typography className="text" variant="h6">
                    CLAIM TOKENS
                  </Typography>
                  <Typography className="text" variant="h4">
                    {active ? (
                      <>{releaseAmount / 100} $BOOM</>
                    ) : (
                      <Skeleton variant="text" />
                    )}
                  </Typography>
                  <Stack
                    alignItems="center"
                    justifyContent="space-between"
                    display="flex"
                    sx={{ height: '100%' }}
                  >
                    <Stack alignItems="center">
                      <Box
                        component="img"
                        sx={{ width: '85%' }}
                        src={Boom}
                      ></Box>

                    </Stack>
                    <Button
                      sx={{ width: '100%' }}
                      variant="contained"
                      onClick={() => claim()}
                      className="claim-button"
                    >
                      CLAIM TOKENS
                    </Button>
                  </Stack>
                </Stack>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  )
}

export default VestingPage
